import { IAutoSuggest } from '../interface/IAutoSuggest';
import axios from "axios";
import { param, toggle, makeEl } from '../common/Utils';
import RecentSearch from './RecentSearch';
import SuggestList from './SuggestList';

export default class Index {

    private option!: IAutoSuggest;
    private loadedKeyword: string = '';
    private dataBaseKeyword: string = '';
    private isValueFunctionText: string = '';
    private sto: NodeJS.Timeout | null = null;
    private suggestWrap!: HTMLElement;
    private inputEl!: HTMLInputElement;
    private submitBtn!: HTMLElement;
    private deleteBtn!: HTMLElement;

    private result: SuggestList;
    private recent: RecentSearch;
    
    constructor(_config: IAutoSuggest) {        
        console.log('-------AutoSuggest START-------', _config);
        const initOption = {
            apiUrl: '',
            cookieName: 'autosuggest',
            selector : '#autoSuggest',
            size: 10,
            useDelbtn: false,
            useRecent: false,
            addParam: {},
            locale: 'ko-KR',
            keywordParamName: 'keyword',
            placeholderStr: '',
            submitCallback: (_q: string) => console.log( 'query :', _q, '::: option.submitCallback 필수 option 입니다' ),
        };

        this.option = {
            ...initOption,
            ..._config
        };

        this.setTempl();
        this.result = new SuggestList(this.option, this.suggestWrap, this.inputEl, ()=>this.submitGo());
        this.recent = new RecentSearch(this.option, this.suggestWrap, this.inputEl, this.deleteBtn, ()=> this.submitGo());
       
        this.addEvents();
	}

    private setTempl() {
        const container = document.querySelector<HTMLElement>( this.option.selector )!;
        const formEl = makeEl('form', container, {
            id: "autoSuggest",
            role: "search",
            'data-name': 'suggest_form',
            onsubmit: "return false;",
        } );
        this.inputEl = makeEl('input', formEl, {
            'data-name': "suggest_input",
            type: "search", autocomplete: "off",
            placeholder: this.option.placeholderStr || '',
        });
        this.deleteBtn = makeEl('button', formEl, {
            'data-name': "suggest_delete", type: "button", value: "Delete",
        });
        this.deleteBtn.style.display = 'none';

        this.submitBtn = makeEl('button', formEl, {
            'data-name': "suggest_submit", type: "button", value: "Search",
        });
        this.suggestWrap = makeEl('div', formEl, { 'data-name': "suggest_wrap" });
    }

    private async load(_newKeyword: string){
        this.loadedKeyword = _newKeyword;

        try {
            const res = await axios({
                method: 'get',
                withCredentials: true,
                url: this.option.apiUrl + '?' + param({
                    [this.option.keywordParamName!]: this.loadedKeyword, 
                    locale: this.option.locale!,
                    size: this.option.size!.toString(),
                    ...this.option.addParam
                }),
            });
            this.drawList(res.data.searchHits);
        } catch (e) {
            console.log('no data');
        }
    }

    private addEvents(){
        let eventT: keyof HTMLElementEventMap = (window._device && window._device==='ingame')? 'keypress': 'keydown';
        
        this.inputEl.addEventListener(eventT, (e: KeyboardEvent)=>{
            if ( e.keyCode === 27 ) { // ESC
                this.inputEl.value = this.loadedKeyword;
                this.result.toggleResult(false);
                return false;
            }

            if ( e.keyCode === 13 ) { // Enter
                this.submitGo();
                // this.submitBtn.focus();
                return false;
            }

            if ( e.keyCode === 9 ) { // Tab
                this.focusChange( !e.shiftKey? 1: -1 );
                return false;
            }

            if ( e.keyCode === 40) { // ↓
                this.focusChange(1);
                return false;
            }

            if ( e.keyCode === 38 ) { // ↑
                this.focusChange(-1);
                return false;
            }
        });

        this.inputEl.addEventListener( 'blur', () => {
            if(this.sto){
                clearTimeout( this.sto );
                this.sto = null;
            }
            setTimeout( () => {
                this.result.toggleResult(false);
                this.recent.toggleRecent(false);
            } , 150 );
        });

        this.inputEl.addEventListener( 'focus', () => {
            this.isValueFunctionText = '';
            if( !this.sto ) this.realTimeInputCheck();
            toggle(this.suggestWrap, true);
            if( this.result.ilLength > 0 ) {
                this.result.toggleResult(true);
            }
        });

        this.submitBtn.addEventListener( 'click', () => this.submitGo() );

        this.deleteBtn.addEventListener( 'click', () => {
            this.loadedKeyword = '';
            this.inputEl.value = '';
            this.inputEl.focus();
        });
    }

    private realTimeInputCheck(){
        if(this.sto){
            clearTimeout( this.sto );
            this.sto = null;
        }

        const inputTxt = this.inputEl.value.trim();

        // 문자열이 있나?
        if( inputTxt ){
            // 바로 앞에서 api 호출한 문자열 인가?
            // 화살표 이동을 통해 입력된 문자열 인가?
            if( this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt ){
                this.recent.toggleRecent(false);
                this.load( inputTxt );
                this.isValueFunctionText = '';
            }
        } else {
            this.recent.toggleRecent(true);
            
            if(this.loadedKeyword != '') {
                setTimeout(()=>{
                    if( this.inputEl.value.trim() ) return;
                    this.loadedKeyword = '';
                }, 10);
            }
            if(this.result.inner != '') {
                setTimeout(()=>{
                    this.result.inner = '';
                    this.result.toggleResult(false);
                }, 10);
            }
        }

        this.deleteBtnToggle(inputTxt);
        this.sto = setTimeout(()=>this.realTimeInputCheck(), 10);
    }

    private deleteBtnToggle(inputTxt = ''){
        if(!this.option.useDelbtn) return false;
        this.deleteBtn.style.display = (inputTxt? 'block': 'none');
    }

    private drawList(_data: {id:string; keyword:string;}[]){
        // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.
        if(!this.inputEl.value.trim()) return;
        this.result.reset(this.loadedKeyword, _data);
    }

    private focusChange( _direction = 1 ){
        let dbKeyword = '';
        if (this.recent.isShow) {
            dbKeyword = this.recent.focusChange(_direction);
        }else{
            dbKeyword = this.result.focusChange(_direction);
        }

        if( dbKeyword ){
            this.dataBaseKeyword = dbKeyword;
        }
    }

    private submitGo() {
        this.result.toggleResult(false);
        this.recent.toggleRecent(false);

        const keyword = this.inputEl.value.trim();

        if (typeof this.option.submitCallback === 'function' && keyword !== '') {
            this.recent.setRecentList( keyword );
            this.option.submitCallback( keyword );
        }
    }
    
    // public ---------------------------------------------------------------------
    public value(_txt: string){
        this.isValueFunctionText = _txt;
        this.inputEl.value = _txt;
    }

}// end of class